import { http } from './config'

export default {
  
  getAllProductFamilies: () => {
    return http.get('product_families')
  },

  getFilteredProductFamilies: (params) => {
    return http.get('product_families', {params})
  },

  getProductFamilyById: (productFamilyId) => {
    return http.get('product_families/' + productFamilyId)
  },

  getProductFamilyByName: (name) => {
    return http.get('product_families/search_by_name/' + name)
  },

  createProductFamily: (productFamilyParams) => {
    return http.post('product_families', {
      name: productFamilyParams.name
    }
  )},

  updateProductFamily: (productFamilyParams) => {
    return http.put('product_families/' + productFamilyParams.productFamilyId, {
      name: productFamilyParams.name
    }
  )},

  deleteProductFamily: (productFamilyId) => {
    return http.delete('product_families/' + productFamilyId)
  },
}
